import(/* webpackMode: "eager" */ "/codebuild/output/src1759725108/src/dgbet/src/app/error.tsx");
